import styles from "../styles/HeaderShortcuts.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import NavigationLink from "../navigation/NavigationLink";
import { Box, IconButton } from "@radix-ui/themes";
import { useT } from "../../utilities/TranslatedText";

type EditableProps = {
  canEdit: true;
  deleteNavigation: (id: number) => void;
  updateNavigation: (navigation: Navigation) => void;
};

type NonEditableProps = {
  canEdit: false;
};

export function Shortcut(
  props: {
    shortcut: Navigation;
    className?: string;
  } & (EditableProps | NonEditableProps),
) {
  const t = useT();

  return (
    <li className={props.className}>
      <div className={styles.editControls}>
        {props.canEdit && (
          <Box>
            <IconButton
              size="1"
              title={t("Edit Link")}
              aria-label={t("Edit Link")}
              onClick={() => props.updateNavigation(props.shortcut)}
            >
              <FontAwesome ariaHidden name={"fa-pen"} prefix={"fas"} />
            </IconButton>
            <IconButton
              size="1"
              color="red"
              title={t("Delete Link")}
              aria-label={t("Delete Link")}
              onClick={() => props.deleteNavigation(props.shortcut.id)}
            >
              <FontAwesome ariaHidden name={"fa-trash"} prefix={"fas"} />
            </IconButton>
          </Box>
        )}
      </div>
      <NavigationLink
        href={props.shortcut.url}
        navigationObj={props.shortcut}
        aria-label={props.shortcut.title}
        className={styles.link}
      >
        <FontAwesome
          fixedWidth
          name={props.shortcut.icon}
          ariaHidden={true}
          className={styles.glyph}
        />
        <div className={styles.label}>
          <div>{props.shortcut.title}</div>
        </div>
      </NavigationLink>
    </li>
  );
}
